export const searchForm = {
  status: undefined,
  title: '',
  line_id: undefined,
  typeid: undefined,
  examine_status: undefined,
  start_date: '',
  end_date: '',
  priority_level: undefined,
  label_id: undefined,
  add_person_keyword: undefined,
  reviewed_keyword: undefined,
  last_modify_keyword: undefined,
  reviewed_at_start: undefined,
  reviewed_at_end: undefined,
  last_modify_at_start: undefined,
  last_modify_at_end: undefined,
}

export const form = {
  line_id: undefined,
  id: undefined,
  // default: 0
}

export const rules = {
  id: [{ required: true, message: '请选择模板名称', trigger: 'change' }],
  line_id: [{ required: true, message: '请选择业务线', trigger: 'change' }],
}
